import CustomLoader from '@anm/components/Loader';
import { FC } from 'react';

import { LoaderContainer } from './Wrapper';

const Loader: FC = () => (
  <LoaderContainer>
    <CustomLoader color="blue" size="medium" />
  </LoaderContainer>
);

export default Loader;
